import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { PropertyForm, PropertyMatch } from '../types';
import { Loader } from 'semantic-ui-react';
import AddressFieldTypeAhead from './AddressFieldTypeAhead';

const Input = styled.input`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  height: 40px;
  :focus {
    outline: none;
  }
`;

interface Props {
  changePropertyInfo: (label: keyof Partial<PropertyForm>, value: any) => void;
  index?: number;
  property: PropertyForm;
  findMatches?: (e: any) => void;
  isLoading: boolean;
  callRpadValidation: any;
  setProperty: React.Dispatch<React.SetStateAction<PropertyForm>>;
  setTypeAheadMatches: React.Dispatch<React.SetStateAction<PropertyMatch[]>>;
  typeAheadMatches: any;
  setAddressResultClicked: React.Dispatch<React.SetStateAction<boolean>>;
  state: any;
}

const PropertySection = (props: Props) => {
  useEffect(() => {}, [props.property]);

  return (
    <div>
      <div style={{ display: 'flex', marginTop: 16 }}>
        <AddressFieldTypeAhead
          findMatches={props.findMatches}
          typeAheadMatches={props.typeAheadMatches}
          callRpadValidation={props.callRpadValidation}
          property={props.property}
          setProperty={props.setProperty}
          setTypeAheadMatches={props.setTypeAheadMatches}
          isLoading={props.isLoading}
          changePropertyInfo={props.changePropertyInfo}
          setAddressResultClicked={props.setAddressResultClicked}
          state={props.state}
        />
        <div style={{ flexDirection: 'column', display: 'flex' }}>
          <label>Unit #</label>
          <Input
            style={{ width: 68, marginTop: 8 }}
            onChange={e => props.changePropertyInfo('unit', e.target.value)}
            value={props.property.unit || ''}
          />
        </div>
      </div>

      <div style={{ display: 'flex', marginTop: 16 }}>
        {props.state.label !== 'NJ' &&<div style={{ flexDirection: 'column', display: 'flex' }}>
          <label>
            {props.property?.selectedCity?.municipalityType === 'Borough' ? 'Borough' : 'Section'}
          </label>
          <Input
            style={{ width: 204, marginRight: 8, marginTop: 8 }}
            onChange={e => props.changePropertyInfo('section', e.target.value)}
            value={props.property.section || ''}
          />
        </div>}
        <div style={{ flexDirection: 'column', display: 'flex' }}>
          <label>Block</label>
          <Input
            style={{ width: 204, marginTop: 8, marginRight: 10 }}
            onChange={e => props.changePropertyInfo('block', e.target.value)}
            value={props.property.block || ''}
          />
        </div>
        <div style={{ flexDirection: 'column', display: 'flex' }}>
          <label>Lot</label>
          <Input
            style={{ width: 204, marginTop: 8 }}
            onChange={e => props.changePropertyInfo('lot', e.target.value)}
            value={props.property.lot || ''}
          />
        </div>
        {props.state.label === 'NJ' && <div style={{ flexDirection: 'column', display: 'flex', marginLeft: 10 }}>
          <label>Qualifier</label>
          <Input
            style={{ width: 204, marginTop: 8 }}
            onChange={e => props.changePropertyInfo('qualifier', e.target.value)}
            value={props.property.qualifier || ''}
          />
        </div>}
      </div>
      <div style={{ flexDirection: 'column', display: 'flex', marginTop: 16 }}>
        <label>Owner name</label>
        <Input
          style={{ width: 630, marginTop: 8 }}
          onChange={e => props.changePropertyInfo('owners', e.target.value)}
          value={props.property.owners || ''}
        />
      </div>
    </div>
  );
};

export default PropertySection;
